// action - state management
import { MENU_ACTIONS } from 'config';

// initial state
export const initialState = {
  openItem: ['dashboard'],
  openComponent: 'buttons',
  selectedID: null,
  drawerOpen: false,
  componentDrawerOpen: true,
  menu: {},
  error: null
};

// ==============================|| AUTH REDUCER ||============================== //

const menu = (state = initialState, action) => {
  switch (action.type) {
    case MENU_ACTIONS.ACTIVE_ITEM: {
      return {
        ...state,
        openItem: action.payload.openItem
      };
    }
    case MENU_ACTIONS.ACTIVE_ID: {
      return {
        ...state,
        selectedID: action.payload
      };
    }
    case MENU_ACTIONS.ACTIVE_COMPONENT: {
      return {
        ...state,
        openComponent: action.payload.openComponent
      };
    }
    case MENU_ACTIONS.OPEN_DRAWER: {
      return {
        ...state,
        drawerOpen: action.payload
      };
    }
    case MENU_ACTIONS.OPEN_COMPONENT_DRAWER: {
      return {
        ...state,
        componentDrawerOpen: action.payload.componentDrawerOpen
      };
    }
    case MENU_ACTIONS.HAS_ERROR: {
      return {
        ...state,
        error: action.payload
      };
    }
    default: {
      return { ...state };
    }
  }
};

export default menu;

